import { Box, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import CalendarRange from "../../../../shared/components/CalendarRange"
import { useScheduled } from "../../../../shared/context/scheduledContext"
import { useEffect } from "react"
import { useParams } from "react-router"


export default function ProgrammingTaskComponent({ readOnly }) {
    const theme = useTheme()

    const { programTask, setProgramTask, scheduleTaskTemplate, groupScheduled, reprogramTaskTemplate, deleteTaskTemplate, deleteProgramTask } = useScheduled()

    const { code_group } = useParams()


    const handleApply = (data) => {
        if(programTask.programmer_dates_created) {
            reprogramTaskTemplate({
                group_scheduled_hash: groupScheduled.hash_code,
                task: programTask.task_scheduled,
                frequency: data.frequency,
                dates_programmed: data.dates_programmed,
            })
        }
        else {
            scheduleTaskTemplate({
                group_scheduled_hash: groupScheduled.hash_code,
                task: programTask.task_scheduled,
                frequency: data.frequency,
                dates_programmed: data.dates_programmed,
            })
        }
    }

    const handleDeleteAll = () => {
        deleteProgramTask(programTask.task_scheduled.id)
        
    }

    return (
        <Box sx={{ padding: '15px' }}>
            <Box>
                <CalendarRange 
                value={programTask.dates_programmed} 
                valueFrecuency={programTask.frequency}
                onApply={handleApply}
                onDeleteAll={handleDeleteAll}
                readOnly={readOnly}
                readOnlyMessage="La tarea ya esta asignada a una OT, no se puede programar"
                />
            </Box>
        </Box>
    )
}